import { app } from '../../../../app';
import { Controller } from './account-register.controller';

app.component('accountRegister', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./account-register.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-register/account-register.component.js